// Hideo - media queries the code reads (the CSS has its own): phone width, mouse or touch, reduced motion
/** Phone layout: the same break as Tailwind's md (768 px) */
export const PHONE_QUERY = '(max-width: 767px)'
export const isPhone = (): boolean => typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches
/** The user asked the system for less motion */
export const reducedMotion = (): boolean => typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
/** A mouse or a trackpad (not a touch screen): a dialog may put the cursor in its first field without the phone keyboard
 *  covering half of it */
export const finePointer = (): boolean => typeof window.matchMedia === 'function' && window.matchMedia('(pointer: fine)').matches
